var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa pull-right clickable",class:{ 'fa-close' : _vm.showfilter  , 'fa-filter' : ! _vm.showfilter  },on:{"click":function($event){_vm.$emit('update:showfilter', !_vm.showfilter) }}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-298fb2f5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FilterButton.vue
// module id = 769
// module chunks = 1